import { httpHelper } from '@/_shared/utils';

const buildForItemsSearch = (tableName, searchFilter = null) => {
  const forAllEntities = !!(tableName === "all");
  if (forAllEntities) {
    const url = new URL('/stock_component/search', process.env.BACKEND_URL);
    for (let attribute in searchFilter) {
      url.searchParams.set(attribute, searchFilter[attribute]);
    }
    return url;
  }
  const url = new URL(`/records/${tableName}`, process.env.BACKEND_URL);
  const { criterion, query, page } = searchFilter;
  url.searchParams.set('filter', `${criterion},cs,${query}`);
  url.searchParams.set('page', page);
  return url;
};

const buildForStockComponentForm = (type, id, joinsList = []) => {
  const specificSlugs = {
    'products': `warehouse/${type}/${id}`,
  };
  const genericSlug = `generated/records/${type}/${id}`;
  const slug = specificSlugs[type] || genericSlug;

  let url = `${process.env.BACKEND_URL}/${slug}`;
  joinsList.forEach((joiningEntity, index) => {
    const prefixSymbol = index === 0 ? "?" : "&";
    url += `${prefixSymbol}join=${joiningEntity}`;
  });
  return url;
};

const buildForStockMovementPage = (filters) => {
  const { searchInTrashBin, page, order, orderColumn } = filters;
  const deletedAtFilter = searchInTrashBin ? 'nis' : 'is';
  let params = `filter=deleted_at,${deletedAtFilter},null&join=purchase_orders`
    + `&join=projects&order=${orderColumn},${order}&page=${page}`
    + '&join=providers&join=users';
  let url = `/records/stock_movement?${params}`;
  url = httpHelper.joinStockEntities(url);
  return url;
};

const urlBuilder = {
  buildForItemsSearch,
  buildForStockComponentForm,
  buildForStockMovementPage,
};

export default urlBuilder;



// WEBPACK FOOTER //
// ./src/stock/api-services/_urlBuilder.js